const initLoader = () => {
  const loader = document.querySelector('[data-loader]')

  if (! loader) {
    document.dispatchEvent(new CustomEvent('worthouse:loader-done'))
    return
  }

  document.body.classList.add('is-loading')

  const complete = () => {
    loader.classList.add('is-complete')
    document.body.classList.remove('is-loading')
    document.dispatchEvent(new CustomEvent('worthouse:loader-done'))

    window.setTimeout(() => {
      loader.remove()
    }, 320)
  }

  const startedAt = Date.now()

  window.addEventListener('load', () => {
    const elapsed = Date.now() - startedAt
    const wait = Math.max(0, 1150 - elapsed)

    window.setTimeout(complete, wait)
  }, { once: true })
}

export default initLoader



// WEBPACK FOOTER //
// ./resources/assets/js/components/loader.js